const assertExhaustive = (x: never): never => {
  throw new Error(`Unexpected object: ${x}`);
};

export default assertExhaustive;
